import React from 'react';
import Marquee from 'react-fast-marquee';
import JCSGR from "../Assets/JCS.jpg"
import Srirama from "../Assets/srirama.jpg";
import Carry from "../Assets/carrycarter.jpg"
import Sunotal from "../Assets/sunotal.jpg"
import JPay from "../Assets/jpay.jpg"
import JTV from "../Assets/jtv.png"
import JFarm from "../Assets/jfarm.jpg"
import JFC from "../Assets/jfc.jpg"

const Brands = () => {
  return (
    <div className="w-full flex flex-col justify-center items-center py-20 px-4  bg-gradient-to-r from-gray-50 to-gray-100">
      {/* Header Section */}
      <div className="w-full flex flex-col text-center mb-12">
        <h2 className="text-3xl sm:text-5xl font-semibold text-gray-800">Our Brands</h2>
      </div>
      
      {/* Marquee Section */}
      <Marquee gradient={false} speed={60} pauseOnHover>
        <img className="h-14 sm:h-20 w-auto mx-6 hover:scale-105 transition-transform duration-300" src={JCSGR} alt='JCSGR' />
        <img className="h-14 sm:h-20 w-auto mx-6 hover:scale-105 transition-transform duration-300" src={Carry} alt='Carry' />
        <img className="h-14 sm:h-20 w-auto mx-6 hover:scale-105 transition-transform duration-300" src={Srirama} alt='Srirama' />
        <img className="h-16 sm:h-24 w-auto mx-6 hover:scale-105 transition-transform duration-300" src={Sunotal} alt='Sunotal' />
        <img className="h-14 sm:h-20 w-auto mx-6 hover:scale-105 transition-transform duration-300" src={JTV} alt='JTV' />
        <img className="h-14 sm:h-20 w-auto mx-6 hover:scale-105 transition-transform duration-300" src={JPay} alt='JPay1' />
        <img className="h-14 sm:h-20 w-auto mx-6 hover:scale-105 transition-transform duration-300" src={JFarm} alt='jfarm' />
        <img className="h-14 sm:h-20 w-auto mx-6 hover:scale-105 transition-transform duration-300" src={JFC} alt='jfc' />
      </Marquee>
    </div>
  );
};

export default Brands;
